var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.5C0.723858 6.5 0.5 6.72386 0.5 7C0.5 7.27614 0.723858 7.5 1 7.5V6.5ZM9.75 1C9.75 0.723858 9.52614 0.5 9.25 0.5C8.97386 0.5 8.75 0.723858 8.75 1H9.75ZM8.75 4C8.75 4.27614 8.97386 4.5 9.25 4.5C9.52614 4.5 9.75 4.27614 9.75 4H8.75ZM5.25 1C5.25 0.723858 5.02614 0.5 4.75 0.5C4.47386 0.5 4.25 0.723858 4.25 1H5.25ZM4.25 4C4.25 4.27614 4.47386 4.5 4.75 4.5C5.02614 4.5 5.25 4.27614 5.25 4H4.25ZM13 6.5H1V7.5H13V6.5ZM1.5 13V4H0.5V13H1.5ZM2.5 14C1.94772 14 1.5 13.5523 1.5 13H0.5C0.5 14.1046 1.39543 15 2.5 15V14ZM2.5 2C1.39543 2 0.5 2.89543 0.5 4H1.5C1.5 3.44772 1.94772 3 2.5 3V2ZM13.5 13V7H12.5V13H13.5ZM13.5 7V4H12.5V7H13.5ZM11.5 15C12.6046 15 13.5 14.1046 13.5 13H12.5C12.5 13.5523 12.0523 14 11.5 14V15ZM11.5 3C12.0523 3 12.5 3.44772 12.5 4H13.5C13.5 2.89543 12.6046 2 11.5 2V3ZM11.5 2H2.5V3H11.5V2ZM11.5 14H2.5V15H11.5V14ZM8.75 1V4H9.75V1H8.75ZM4.25 1V4H5.25V1H4.25Z",
    fill: "#2AB7F8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7faa056c1ae31bf4933a40317c2ba474.svg";
export { ForwardRef as ReactComponent };